// extracted by mini-css-extract-plugin
module.exports = {"container":"PositionBriefCard_container__2gxxY","description":"PositionBriefCard_description__2xN6D","title":"PositionBriefCard_title__2dWbL"};